var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.728,
    height: 20.222,
    viewBox: "0 0 31.728 20.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M31.526,102.329c-.283-.388-7.037-9.494-15.662-9.494S.484,101.941.2,102.329a1.047,1.047,0,0,0,0,1.235c.283.388,7.037,9.494,15.662,9.494s15.379-9.106,15.662-9.494A1.046,1.046,0,0,0,31.526,102.329Zm-15.662,8.636c-6.354,0-11.856-6.044-13.485-8.02,1.627-1.978,7.118-8.018,13.485-8.018s11.856,6.043,13.485,8.02C27.722,104.924,22.231,110.965,15.864,110.965Z",
    transform: "translate(0 -92.835)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(9.588 3.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M161,154.725A6.276,6.276,0,1,0,167.274,161,6.283,6.283,0,0,0,161,154.725Zm0,10.46A4.184,4.184,0,1,1,165.182,161,4.189,4.189,0,0,1,161,165.185Z",
    transform: "translate(-154.722 -154.725)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.dd6e947942a30ae892708583e32b0aa6.svg";
export { ForwardRef as ReactComponent };